import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

import { TicketModel } from '~app/models/ticket.model';
import { BaseSidebarHeaderAdditionalInfoComponent } from '~components/sidebar-components/edit-sidebar/base-edit-sidebar-header-additional-info.component';

@Component({
    selector: 'arc-ticket-header-title-additional-info',
    templateUrl: './ticket-header-title-additional-info.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [MatIconButton, CdkCopyToClipboard, MatIcon]
})
export class TicketHeaderTitleAdditionalInfoComponent extends BaseSidebarHeaderAdditionalInfoComponent<TicketModel> {
    readonly ticketLink = computed(() => `${window.location.protocol}//${window.location.host}/support/tickets?Id=${this.item().id}`);

    onItemSet(): void {}
}
